'use client';
import { PropsWithChildren } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { listProps } from '../types';

interface Props {
  id?: string;
  formMethods: UseFormReturn<{
    selectedEquipment: listProps;
    serial: string;
    nickName: string;
    model: string;
  }>;
  handleSubmit: () => void;
}

export const MyEquipmentForm = ({
  id,
  children,
  formMethods,
  handleSubmit
}: PropsWithChildren<Props>) => {
  return (
    <div>
      <FormProvider {...formMethods}>
        <form
          id={id}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          {children}
        </form>
      </FormProvider>
    </div>
  );
};
